import { useQuery } from '@apollo/client';
import { useMemo, useEffect, useState } from 'react';
import { GET_ACCOUNT_TMS_DRIVERS_BY_CARRIER_ID, GetAccountTmsDriversByCarrierIdResponse } from '../schedule/graphql/queries/getAccountTmsDriversByCarrierId';
import { useTmsSearch } from './useTmsSearch';
import { TmsStatusEnum } from 'enums/TmsEnum';

/**
 * TMS根据路线获取司机Hook
 * 根据路线ID获取对应的承运商，然后获取该承运商下的司机列表
 */
export const useTmsDriversByRoute = (routeId: string | number | undefined) => {
    const { getRouteWithCarrierInfoById } = useTmsSearch();
    const [selectedCarrierId, setSelectedCarrierId] = useState<number | null>(null);
    const [selectedRouteType, setSelectedRouteType] = useState<number | undefined>(undefined);

    // 根据路线ID获取承运商ID和路线类型
    useEffect(() => {
        const fetchCarrierId = async () => {
            if (!routeId) {
                setSelectedCarrierId(null);
                setSelectedRouteType(undefined);
                return;
            }

            const route = await getRouteWithCarrierInfoById(routeId);
            setSelectedCarrierId(route?.carrierId || null);
            setSelectedRouteType(route?.routeType);
        };

        fetchCarrierId();
    }, [routeId, getRouteWithCarrierInfoById]);

    // 根据承运商ID获取司机，限制状态为Active，传 routeType 让后端判断交接类型返回空
    const { data: driversData } = useQuery<GetAccountTmsDriversByCarrierIdResponse>(
        GET_ACCOUNT_TMS_DRIVERS_BY_CARRIER_ID,
        {
            variables: { carrierId: selectedCarrierId, status: TmsStatusEnum.Active, routeType: selectedRouteType },
            skip: !selectedCarrierId
        }
    );

    // 根据选择的承运商ID获取司机选项
    const driverOptions = useMemo(() => {
        if (!driversData?.getAccountTmsDriversByCarrierId) return [];
        return driversData.getAccountTmsDriversByCarrierId.map(driver => ({
            label: driver.driverName || '',
            value: driver.id.toString() // 使用 AccountTmsDriver 的 id
        }));
    }, [driversData]);

    return {
        driverOptions,
        selectedCarrierId,
        driversData
    };
};

